





















































































































































import {
  computed,
  defineComponent,
  reactive,
  watch,
} from "@vue/composition-api";
import {
  Button,
  InputContainer,
  SearchableSelect,
} from "@micad/vue-components";
import router from "@/router";
import { displayRequestStatus } from "@/notifications";
import {
  userProfile,
  userProfileCreate,
  userProfileDelete,
  userProfileUpdate,
} from "@/data/repos/userProfiles";
import { UserProfile } from "@/data/repos/commonModels";
import { SelectOption } from "@micad/vue-components/src/common/interfaces";
import { Icon2 } from "@micad/vue-components";
import { QBadge, QChip, QIcon, QSelect } from "quasar";
import Loading from "@/components/Loading.vue";
import { canIUse } from "@/modules/auth";
import ModalContainer from "@/components/ModalContainer.vue";
import { getAccountsApps } from "@/data/repos/apps";
import { App } from "@/interfaces/common.interfaces";

export default defineComponent({
  name: "ProfileCreate",
  methods: { canIUse },
  props: { id: String },
  components: {
    ModalContainer,
    QIcon,
    Icon2,
    Loading,
    QChip,
    QSelect,
    InputContainer,
    Button,
    SearchableSelect,
    QBadge,
  },
  setup() {
    const state = reactive({
      profileId: router.currentRoute.params.id
        ? parseInt(router.currentRoute.params.id, 10)
        : undefined,
      userProfile: {
        role: "",
        applications: [],
      } as UserProfile,
      roleSelectOptions: [
        { label: "Admin", value: "Admin" },
        { label: "User", value: "User" },
        { label: "Viewer", value: "Viewer" },
      ],
      appsSelectOptions: [] as App[],
      selectedApps: [] as App[],
      selectedRole: computed((): SelectOption => {
        return state.userProfile.role
          ? { label: state.userProfile.role, value: state.userProfile.role }
          : { label: "<None>", value: "" };
      }),
      serverErrorMessage: "",
      busy: false,
      loading: true,
      roleSelect: (v: SelectOption) => {
        state.userProfile.role = v.value;
        // state.selectedRole = { ...v };
      },
      submit,
      resetForm,
      goBack: () => router.back(),
      deleteProfile,
      deleteProfileDialogShow,
      deleteProfileDialog: false,
    });

    watch(
      () => state.selectedApps,
      () =>
        (state.userProfile.applications = state.selectedApps.map(
          (v: App) => v.id
        ))
    );

    async function resetForm() {
      state.userProfile.role = "";
      state.userProfile.applications = [];
      state.userProfile.name = "";
      state.userProfile.description = "";
    }

    async function submit() {
      state.busy = true;
      if (state.profileId) {
        const resp = await userProfileUpdate(state.userProfile);
        state.serverErrorMessage = resp.ok
          ? ""
          : resp.status?.errorMessage || "";
        displayRequestStatus(
          resp,
          "User profile has been updated",
          "Failed to update user profile. Internal server error."
        );
        if (!resp.ok) return;
      } else {
        const resp = await userProfileCreate(state.userProfile);
        state.serverErrorMessage = resp.ok
          ? ""
          : resp.status?.errorMessage || "";
        displayRequestStatus(
          resp,
          "User profile has been created",
          "Failed to create user profile. Internal server error."
        );
        if (!resp.ok) return;
      }
      await router.push({ name: "UserProfiles" });
      state.busy = false;
      return false;
    }

    async function refresh() {
      state.appsSelectOptions = (await getAccountsApps()).payload || [];
      if (!state.profileId) return;
      const resp = await userProfile({ id: state.profileId } as UserProfile);
      if (resp.ok) Object.assign(state.userProfile, resp.payload);
      // Lookup title in all apps list, use id if not found
      const lookupAppTitle = (id: string) =>
        (state.appsSelectOptions.find((app) => app.id === id) || {}).title ||
        id;
      state.selectedApps =
        resp
          .payload!.applications!.map((id) => ({
            id,
            title: lookupAppTitle(id),
          }))
          .filter((v) => v.id) || [];
    }

    setTimeout(async () => {
      state.loading = true;
      await refresh();
      state.loading = false;
    }, 0);

    function deleteProfileDialogShow() {
      state.deleteProfileDialog = true;
    }
    function deleteProfile() {
      console.log("delete");
      state.busy = true;
      userProfileDelete(state.userProfile)
        .then((resp) => {
          displayRequestStatus(
            resp,
            "User profile has been deleted",
            "Failed to delete user profile. Internal server error."
          );
          if (resp.ok) {
            router.push({ name: "UserProfiles" });
          }
        })
        .finally(() => {
          state.busy = false;
          state.deleteProfileDialog = false;
        });
    }

    return state;
  },
});
